import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import data from "../../src/component/ApiUrl/meta_api";
import { Helmet } from "react-helmet";
import "../assets/css/Omron.css";

function Omron() {
  const [meta, setMeta] = useState(null);
  const fetchData = () => {
    const OmronMeta = data[0]?.Omron_page;
    if (OmronMeta) {
      setMeta(OmronMeta);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  return (
    <>
      {/* Page Header */}
      <div className="container-fluid page-header py-5 mb-5 animate__animated animate__fadeIn">
        <Helmet>
          <title>{meta ? meta.title : "Omron - SKimitar Hindustan"}</title>
          <meta
            name="description"
            content="Learn about Skimitar Hindustan's PLC,HMI and Variable Frequency Drives in industrial automation solutions."
          />
        </Helmet>
        <div className="container py-5">
          <h1 className="display-3 text-white animate__animated animate__slideInRight">
            Omron
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animate__animated animate__slideInRight mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/">Products</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Omron
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="automation-showcase">
        <section className="product-section py-5 bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 order-lg-1 order-2" data-aos="fade-up">
                <div className="section-header mb-4">
                  <h1 className="section-title text-danger">
                    Omron <span className="text-dark">Sensors</span>
                  </h1>
                </div>

                <div className="feature-list">
                  <div className="feature-card">
                    <div className="feature-icon bg-danger">
                      <i className="fas fa-lightbulb"></i>
                    </div>
                    <div className="feature-content">
                      <h4>Fiber Sensors</h4>
                      <p className=" fs-6">
                        Transmit light through optical fibers for detection in
                        narrow spaces with precision and reliability.
                      </p>
                    </div>
                  </div>

                  <div className="feature-card">
                    <div className="feature-icon bg-danger">
                      <i className="fas fa-bullseye"></i>
                    </div>
                    <div className="feature-content">
                      <h4>Photoelectric Sensors</h4>
                      <p className=" fs-6">
                        Detect objects using diffuse-reflective, through-beam,
                        and retro-reflective methods for versatile applications.
                      </p>
                    </div>
                  </div>

                  <div className="feature-card">
                    <div className="feature-icon bg-danger">
                      <i className="fas fa-ruler-combined"></i>
                    </div>
                    <div className="feature-content">
                      <h4>Displacement Sensors</h4>
                      <p className=" fs-6">
                        Measure distance, height, and thickness using advanced
                        laser and ultrasonic technology.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-6 order-lg-2 order-1 mb-4 mb-lg-0"
                data-aos="fade-left"
              >
                <div className="image-container">
                  <img
                    className="img-fluid rounded shadow-lg"
                    src={require("../assets/img/products/Omron/20.jpg")}
                    alt="Omron Sensors"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: Switches */}
        <section className="product-section py-5 bg-white">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6   mb-lg-0" data-aos="fade-right">
                <div className="image-container">
                  <img
                    className="img-fluid rounded shadow-lg"
                    src={require("../assets/img/products/Omron/22.jpg")}
                    alt="Omron Switches"
                  />
                  {/* <div className="image-badge bg-danger">Reliable Control</div> */}
                </div>
              </div>

              <div className="col-lg-6" data-aos="fade-up">
                <div className="section-header ">
                  <h2 className="section-title text-danger mb-3">
                    Omron <span className="text-dark">Switches</span>
                  </h2>
                </div>

                <div className="product-highlight">
                  <h4 className="highlight-title">
                    <i className="fas fa-check-circle text-danger me-2"></i>
                    A22NS / A22NW Selector Switches
                  </h4>
                  <p className="highlight-description fs-6">
                    Compact and efficient 22-mm diameter switches designed for
                    control panel applications with superior durability.
                  </p>

                  <div className="specs-boxs  ">
                    <h5>Key Features</h5>
                    <ul className="specs-list">
                      <li>
                        22-mm compact design for space-saving installation
                      </li>
                      <li>High durability with long mechanical life</li>
                      <li>Variety of actuator styles and colors</li>
                      <li>Positive tactile feedback for reliable operation</li>
                    </ul>
                  </div>

                  <div className="applications mt-4">
                    <h5>Applications</h5>
                    <div className="app-grid">
                      <div className="app-card">
                        <i className="fas fa-industry text-danger"></i>
                        <span>Industrial Machinery</span>
                      </div>
                      <div className="app-card">
                        <i className="fas fa-robot text-danger"></i>
                        <span>Automation Systems</span>
                      </div>
                      <div className="app-card">
                        <i className="fas fa-bolt text-danger"></i>
                        <span>Power Distribution</span>
                      </div>
                      <div className="app-card">
                        <i className="fas fa-fan text-danger"></i>
                        <span>HVAC Controls</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3: Relays */}
        <section className="product-section py-5 bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 order-lg-1 order-2" data-aos="fade-up">
                <div className="section-header mb-4">
                  <h2 className="section-title text-danger mb-3">
                    Omron <span className="text-dark">Relays</span>
                  </h2>
                </div>

                <div className="relay-types">
                  <div className="type-card">
                    <div className="type-header bg-danger">
                      <h4>General-Purpose</h4>
                    </div>
                    <p className=" fs-6">
                      Versatile relays for control panels and built-in
                      applications across industries.
                    </p>
                  </div>

                  <div className="type-card">
                    <div className="type-header bg-danger">
                      <h4>Solid-State (SSR)</h4>
                    </div>
                    <p className=" fs-6">
                      Semiconductor-based relays for high-speed switching and
                      precise heater control.
                    </p>
                  </div>

                  <div className="type-card">
                    <div className="type-header bg-danger">
                      <h4>Power Relays</h4>
                    </div>
                    <p className=" fs-6">
                      High-capacity relays designed for heavy electrical loads
                      and industrial applications.
                    </p>
                  </div>

                  <div className="type-card">
                    <div className="type-header bg-danger">
                      <h4>Signal Relays</h4>
                    </div>
                    <p className=" fs-6">
                      Compact relays for low-power applications in communication
                      and control systems.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-6 order-lg-2 order-1 mb-4 mb-lg-0"
                data-aos="fade-left"
              >
                <div className="image-container">
                  <img
                    className="img-fluid rounded shadow-lg"
                    src={require("../assets/img/products/Omron/24.jpg")}
                    alt="Omron Relays"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 4: Safety Components */}
        <section
          className="product-section py-5"
          style={{ backgroundColor: "#EBF3F9" }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-right">
                <div className="image-container">
                  <img
                    className="img-fluid rounded shadow-lg"
                    src={require("../assets/img/products/Omron/23.png")}
                    alt="Safety Components"
                  />
                </div>
              </div>

              <div className="col-lg-6" data-aos="zoom-out">
                <div className="section-header mb-4">
                  <span className="section-subtitle text-uppercase text-dark">
                    Safety First
                  </span>
                  <h2 className="section-title text-danger mb-3">
                    Industrial <span className="">Safety Components</span>
                  </h2>
                </div>

                <div className="safety-features">
                  <div className="safety-card">
                    <div className="safety-icon">
                      <i className="fas fa-shield-alt"></i>
                    </div>
                    <div className="safety-content">
                      <h4>Safety Relays</h4>
                      <p className=" fs-6">
                        Forced guided relays ensure fail-safe operation in
                        industrial equipment with redundant contacts.
                      </p>
                    </div>
                  </div>

                  <div className="safety-card">
                    <div className="safety-icon">
                      <i className="fas fa-exclamation-triangle"></i>
                    </div>
                    <div className="safety-content">
                      <h4>Emergency Stop Systems</h4>
                      <p className=" fs-6">
                        Immediate shutdown capability for critical situations
                        with positive opening contacts.
                      </p>
                    </div>
                  </div>

                  <div className="safety-card">
                    <div className="safety-icon">
                      <i className="fas fa-hands"></i>
                    </div>
                    <div className="safety-content">
                      <h4>Two-Hand Control</h4>
                      <p className=" fs-6">
                        Prevents accidental machine activation by requiring
                        simultaneous two-hand operation.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="safety-applications mx-5 mt-4">
                  <h5 className="text-danger">Safety Solutions For:</h5>
                  <div className="app-tags">
                    <span className="tag fs-6">Robotic Cells</span>
                    <span className="tag fs-6">Press Machines</span>
                    <span className="tag fs-6">Conveyor Systems</span>
                    <span className="tag fs-6">Packaging Lines</span>
                    <span className="tag fs-6">Assembly Stations</span>
                  </div>
                </div>

                <div className="safety-standards mx-5 mt-4">
                  <h6 className="">Compliant with International Standards:</h6>
                  <div className="standards-logos">
                    <span className="tag fs-6">ISO 13849</span>
                    <span className="tag fs-6">IEC 62061</span>
                    <span className="tag fs-6">UL 508</span>
                    <span className="tag fs-6">CE</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="container px-0 mt-5">
        <div
          className="card card-lg-expand shadow-lg border-0 rounded-4 overflow-hidden"
          data-aos="fade-left"
        >
          <div className="row g-0 align-items-stretch">
            {/* Text Section */}
            <div className="col-lg-8 p-4 p-lg-5 d-flex flex-column justify-content-center bg-gradient-light">
              <div className="card-body p-0">
                <h2
                  className="text-gradient-primary fw-bold mb-4"
                  data-aos="fade-left"
                >
                  Control Components
                </h2>
                <p className="lead text-dark mb-4 fs-6">
                  M22N Indicators: Compact 22-mm Diameter Indicators for
                  Miniaturized Control Panels.
                </p>
                <ul className="list-unstyled text-dark mb-0">
                  <li className="mb-3 d-flex align-items-start">
                    <span className="icon-circle bg-danger me-3">
                      <i className="fas fa-compress-alt text-white"></i>
                    </span>
                    <div className="">
                      <strong>Compact Design:</strong> Fits easily into small
                      control panels.
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <span className="icon-circle bg-danger me-3">
                      <i className="fas fa-lightbulb text-white"></i>
                    </span>
                    <div>
                      <strong>High Visibility:</strong> Bright LED indicators
                      for clear status signaling.
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <span className="icon-circle bg-danger me-3">
                      <i className="fas fa-shield-alt text-white"></i>
                    </span>
                    <div>
                      <strong>Durability:</strong> Built with high-quality
                      materials for long-lasting performance.
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <span className="icon-circle bg-danger me-3">
                      <i className="fas fa-tools text-white"></i>
                    </span>
                    <div>
                      <strong>Easy Installation:</strong> Standard 22-mm
                      mounting size with simple wiring.
                    </div>
                  </li>
                  <li className="d-flex align-items-start">
                    <span className="icon-circle bg-danger me-3">
                      <i className="fas fa-cogs text-white"></i>
                    </span>
                    <div>
                      <strong>Versatile Applications:</strong> Suitable for
                      industrial machinery, automation systems, and process
                      control panels.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Image Section */}
            <div className="col-lg-4 d-flex align-items-center justify-content-center p-4 bg-white">
              <div className="position-relative w-100 h-100">
                <img
                  className="img-fluid rounded-3 shadow-sm w-100 h-auto"
                  src={require("../assets/img/products/Omron/25.jpg")}
                  alt="M22N Indicator"
                  style={{ objectFit: "contain", maxHeight: "400px" }}
                />
                <div className="position-absolute top-0 end-0 mt-3 me-3">
                  <span className="badge bg-danger px-3 py-2 rounded-pill shadow">
                    <i className="fas fa-bolt me-2"></i>Premium Quality
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="card mt-5 border-0 overflow-hidden"
        style={{
          backgroundColor: "#f8f9fa",
          borderRadius: "20px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        }}
      >
        <div className="container-fluid p-0">
          <div className="row g-0 align-items-stretch">
            {/* Image Section */}
            <div
              className="col-lg-6 col-md-6 order-md-1 order-2"
              data-aos="fade-left"
            >
              <div
                className="p-4 p-xl-5 h-100 d-flex align-items-center"
                style={{
                  background:
                    "linear-gradient(135deg, #f1f3f5 0%, #e9ecef 100%)",
                }}
              >
                <img
                  className="img-fluid mx-auto d-block"
                  src={require("../assets/img/products/Omron/27-removebg-preview.png")}
                  alt="Motion & Drives"
                  style={{
                    maxHeight: "400px",
                    filter: "drop-shadow(0 10px 15px rgba(0,0,0,0.1))",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                />
              </div>
            </div>

            {/* Content Section */}
            <div
              className="col-lg-6 col-md-6 order-md-2 order-1"
              data-aos="fade-right"
            >
              <div
                className="p-4 p-md-5 h-100"
                style={{
                  background: "white",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Decorative elements */}
                <div
                  style={{
                    position: "absolute",
                    top: "-50px",
                    right: "-50px",
                    width: "200px",
                    height: "200px",
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(220,53,69,0.1) 0%, rgba(255,255,255,0) 70%)",
                    zIndex: 0,
                  }}
                ></div>

                <div
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "20px",
                    width: "100px",
                    height: "100px",
                    background:
                      "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48cGF0aCBkPSJNMjAsMjBDMjAsNDAgNDAsNjAgNTAsODBDNjAsNjAgODAsNDAgODAsMjBDODAsMCA1MCwwIDUwLDMwQzUwLDAgMjAsMCAyMCwyMFoiIGZpbGw9IiNkYzM1NDUiIGZpbGwtb3BhY2l0eT0iMC4xIi8+PC9zdmc+')",
                    opacity: 0.3,
                    zIndex: 0,
                  }}
                ></div>

                <div className="position-relative" style={{ zIndex: 1 }}>
                  <h2
                    className="text-danger fw-bold mb-4"
                    style={{
                      fontSize: "2.2rem",
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    Motion & Drives
                    <span
                      style={{
                        position: "absolute",
                        bottom: "-10px",
                        left: "0",
                        width: "60px",
                        height: "3px",
                        background: "#dc3545",
                        borderRadius: "3px",
                      }}
                    ></span>
                  </h2>

                  <p className="lead fw-bold mb-4" style={{ color: "#212529" }}>
                    Multi-Function Compact Inverter 3G3MX2-V2
                  </p>

                  <p
                    className="mb-4 fs-6"
                    style={{ color: "#495057", lineHeight: "1.7" }}
                  >
                    The 3G3MX2-V2 Compact Inverter is designed for precise motor
                    control, including simple positioning and permanent magnet
                    (PM) motor control. With advanced features, it enhances
                    efficiency, flexibility, and performance in automation and
                    motion control applications.
                  </p>

                  <ul className="list-unstyled mb-4">
                    <li className="mb-3 d-flex align-items-start">
                      <span
                        className="badge bg-danger rounded-circle p-2 me-3"
                        style={{
                          minWidth: "32px",
                          minHeight: "32px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </span>
                      <span style={{ flex: 1, color: "#343a40" }}>
                        <strong>High-Performance Motor Control</strong> -
                        Supports both induction and PM motors with smooth speed
                        regulation.
                      </span>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <span
                        className="badge bg-danger rounded-circle p-2 me-3"
                        style={{
                          minWidth: "32px",
                          minHeight: "32px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </span>
                      <span style={{ flex: 1, color: "#343a40" }}>
                        <strong>Compact & Space-Saving Design</strong> - Ideal
                        for applications where space is limited.
                      </span>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <span
                        className="badge bg-danger rounded-circle p-2 me-3"
                        style={{
                          minWidth: "32px",
                          minHeight: "32px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </span>
                      <span style={{ flex: 1, color: "#343a40" }}>
                        <strong>Built-In Safety Functions</strong> - Includes
                        safe torque off (STO) for enhanced protection.
                      </span>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <span
                        className="badge bg-danger rounded-circle p-2 me-3"
                        style={{
                          minWidth: "32px",
                          minHeight: "32px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </span>
                      <span style={{ flex: 1, color: "#343a40" }}>
                        <strong>Easy Integration</strong> - Compatible with
                        various industrial networks (Modbus, EtherCAT, etc.).
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5 pt-4 pb-5">
        <div
          className="card shadow-lg border-0 rounded-4 overflow-hidden position-relative"
          data-aos="fade-up"
          style={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)",
            borderLeft: "6px solid #4e73ff",
          }}
        >
          {/* Decorative elements */}
          <div className="position-absolute top-0 end-0 w-50 h-100 opacity-10">
            <div
              className="w-100 h-100"
              style={{
                background:
                  "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxwYXR0ZXJuIGlkPSJwYXR0ZXJuIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHBhdHRlcm5UcmFuc2Zvcm09InJvdGF0ZSg0NSkiPjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0icmdiYSg3OCwgMTE1LCAyNTUsIDAuMDUpIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI3BhdHRlcm4pIi8+PC9zdmc+')",
              }}
            ></div>
          </div>

          <div className="row g-0 align-items-stretch">
            {/* Text Section */}
            <div className="col-lg-6 col-md-6 p-4 p-lg-5 d-flex flex-column justify-content-center position-relative">
              <div className="card-body p-0">
                <div className="d-flex align-items-center mb-3">
                  <div className="icon-square bg-danger bg-opacity-10 text-danger rounded-3 me-3 p-2">
                    <i className="fas fa-robot fs-4"></i>
                  </div>

                  <h2
                    className="text-gradient-primary fw-bold mt-1 "
                    data-aos="fade-left"
                  >
                    Automation Systems
                  </h2>
                </div>

                <p className="lead text-dark mt-3 mb-4">
                  <strong className="text-danger">
                    Programmable Controllers (PLCs):
                  </strong>{" "}
                  Modern industrial automation relies on Programmable Logic
                  Controllers (PLCs) for high-speed and high-precision control.
                </p>

                <div className="bg-light   rounded-3 mb-4">
                  <p className="mb-0  text-dark">
                    These controllers are essential for automating
                    manufacturing, process control, and industrial operations,
                    ensuring reliability, efficiency, and scalability.
                  </p>
                </div>

                <h5 className="text-danger mb-3">
                  <i className="fas fa-star me-2"></i>Key Products & Features
                </h5>

                <div className="d-flex align-items-start mb-3">
                  <span className="badge bg-danger bg-opacity-10 text-danger rounded-pill me-3 px-3 py-2">
                    PLCs
                  </span>
                  <span className="text-muted">DVP & AS Series</span>
                </div>

                <ul className="list-unstyled mb-0">
                  <li className="mb-2 d-flex align-items-start">
                    <span className="text-danger me-2 mt-1">✓</span>
                    <span className="text-dark">
                      High-speed processing for real-time automation
                    </span>
                  </li>
                  <li className="mb-2 d-flex align-items-start">
                    <span className="text-danger me-2 mt-1">✓</span>
                    <span className="text-dark">
                      Modular design for easy expansion
                    </span>
                  </li>
                  <li className="d-flex align-items-start">
                    <span className="text-danger me-2 mt-1">✓</span>
                    <span className="text-dark">
                      Advanced communication interfaces (Ethernet, Modbus,
                      CANopen)
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Image Section */}
            <div className="col-lg-6 col-md-6 position-relative">
              <div className="h-100 w-100 overflow-hidden">
                <img
                  className="img-fluid w-100 h-100 object-fit-cover"
                  src={require("../assets/img/products/Omron/26.jpg")}
                  alt="Automation Systems"
                  style={{ minHeight: "300px" }}
                />
                <div
                  className="position-absolute bottom-0 start-0 w-100 p-3"
                  style={{
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="" data-aos="zoom-in">
        <div
          className=" border-0 overflow-hidden"
          style={{
            borderRadius: "20px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
            background: "linear-gradient(to right, #ffffff 0%, #f8f9fa 100%)",
          }}
        >
          <div className="row g-0 align-items-stretch">
            {/* Image Section */}
            <div className="col-lg-5 order-lg-1 order-2">
              <div
                className="h-100 d-flex align-items-center justify-content-center p-4 "
                style={{
                  background:
                    "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
                  minHeight: "400px",
                }}
              >
                <img
                  className="img-fluid"
                  src={require("../assets/img/products/Omron/28-removebg-preview.png")}
                  alt="Robotics"
                  style={{
                    maxHeight: "350px",
                    filter: "drop-shadow(0 15px 20px rgba(0,0,0,0.15))",
                    transition: "transform 0.4s ease",
                    transform: "translateY(0)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                />
              </div>
            </div>

            {/* Content Section */}
            <div className="col-lg-7 order-lg-2 order-1">
              <div className="h-100 p-4 p-lg-5 position-relative">
                {/* Decorative elements */}
                <div
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    width: "80px",
                    height: "80px",
                    background:
                      "radial-gradient(circle, rgba(220,53,69,0.08) 0%, rgba(255,255,255,0) 70%)",
                    borderRadius: "50%",
                  }}
                ></div>

                <div className="position-relative" style={{ zIndex: 1 }}>
                  {/* Main Heading */}
                  <div className="d-flex align-items-center mb-4">
                    <div
                      style={{
                        // width: "40px",
                        // height: "4px",
                        background: "#dc3545",
                        marginRight: "15px",
                      }}
                    ></div>

                    <h2
                      className="text-gradient-primary fw-bold mb-1"
                      data-aos="fade-left"
                    >
                      Robotics Solutions
                    </h2>
                  </div>

                  {/* Main Description */}
                  <div className="d-flex align-items-start mb-4">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#dc3545"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="me-3 flex-shrink-0"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <p
                      className="lead text-dark mb-0"
                      style={{ lineHeight: "1" }}
                    >
                      Advanced automation solutions for industrial manufacturing
                      with precision and efficiency.
                    </p>
                  </div>

                  {/* Cobots Section */}
                  <div
                    className="mb-4 p-4"
                    style={{
                      background: "rgba(220,53,69,0.03)",
                      borderLeft: "4px solid #dc3545",
                      borderRadius: "0 8px 8px 0",
                    }}
                  >
                    <h3 className="fw-bold text-danger mb-2 d-flex align-items-center">
                      <span
                        className="me-2"
                        style={{ fontSize: "1.8rem" }}
                      ></span>
                      <span>Collaborative Robots (Cobots)</span>
                    </h3>
                    <p
                      className="mb-0"
                      style={{ color: "#495057", lineHeight: "1.2" }}
                    >
                      Designed for safe interaction with human operators, these
                      robots excel in tasks like machine tending, assembly, and
                      packaging with unmatched precision and adaptability.
                    </p>
                  </div>

                  {/* Power Supplies Section */}
                  <div
                    className=" p-4 p-lg-4 border-0 rounded"
                    style={{
                      background: "white",
                      boxShadow: "0 5px 20px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div className="d-flex align-items-center mb-2">
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          background: "#dc3545",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "12px",
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                          <polyline points="13 2 13 9 20 9"></polyline>
                        </svg>
                      </div>
                      <h4 className="fw-bold mb-0" style={{ color: "#212529" }}>
                        Power Solutions
                      </h4>
                    </div>

                    <div className="d-flex align-items-start mb-3">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#dc3545"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="me-2 flex-shrink-0 mt-1"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      <p
                        className="text-muted mb-0"
                        style={{ lineHeight: "1.6" }}
                      >
                        Industrial-grade power supplies delivering reliable
                        energy solutions for demanding automation environments.
                      </p>
                    </div>

                    <div className="d-flex align-items-center mb-3">
                      <div
                        style={{
                          width: "30px",
                          height: "30px",
                          background: "#dc3545",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "12px",
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                          <polyline points="13 2 13 9 20 9"></polyline>
                        </svg>
                      </div>
                      <h4 className="fw-bold mb-0" style={{ color: "#212529" }}>
                        Switch Mode Power Supplies
                      </h4>
                    </div>

                    <div className="d-flex align-items-start mb-3">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#dc3545"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="me-2 flex-shrink-0 mt-1"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      <p
                        className="text-muted mb-0"
                        style={{ lineHeight: "1.6" }}
                      >
                        Compact and efficient units offering reliable
                        performance across various power ratings and output
                        voltages.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Omron;
